import {
    h,
    renderSlot,
    ref,
    reactive,
    onMounted,
    Transition,
} from 'vue'

import './style.scss'

const AExpand = {
    name: 'AExpand',
    props: {},
    setup: (props, ctx) => {

        const state = reactive({
            active: false,
            timing: 300,
        })

        const expandBody = ref(null)
        const expandContent = ref(null)

        const toggle = () => {
            state.active = !state.active
            state.active ? show() : hide()
        }

        const show = () => {
            expandContent.value.style.display = `block`
            expandBody.value.style.height = `0px`
            expandBody.value.style.overflow = `hidden`
            setTimeout(() => {
                expandBody.value.style.transition = `all ${state.timing / 1000}s ease`
                expandBody.value.style.height = `${expandContent.value.scrollHeight}px`

                setTimeout(() => {
                    expandBody.value.style.transition = null
                    expandBody.value.style.height = null
                    expandBody.value.style.overflow = null
                    expandContent.value.style.display = null
                }, state.timing)
            })
        }

        const hide = () => {
                expandBody.value.style.transition = `all ${state.timing / 1000}s ease`
                expandBody.value.style.height = `${expandContent.value.scrollHeight}px`
                expandBody.value.style.overflow = `hidden`

                setTimeout(() => {
                    expandBody.value.style.height = `0px`
                    setTimeout(() => {
                        expandBody.value.style.transition = null
                        expandBody.value.style.height = null
                        expandBody.value.style.overflow = null
                        expandContent.value.style.display = `none`
                    }, state.timing)
                })
        }

        const render = () => h('div', {
            ...ctx.attrs,
            class: [
                'a-expand',
                ctx.attrs.class,
            ],
        }, [
            h('div', {
                class: ['a-expand-inner']
            }, [
                h('div', {
                    class: 'a-expand-header',
                    onClick: toggle,
                }, renderSlot(ctx.slots, 'header')),
                h('div', {
                    class: 'a-expand-body',
                    ref: expandBody,
                }, h('div', {
                    class: ['a-expand-content'],
                    ref: expandContent,
                    style: {display: 'none'},
                }, renderSlot(ctx.slots, 'body'))),
            ]
        )])

        return () => render()
    }
}

export {
    AExpand
}